// #2364 (scribe-presence workstream, card C) — a tiny mutable store for
// "what this scribe-fe instance currently has open": the ring/classId/
// rideId/seat context that ScoringForm sets while mounted (and clears on
// unmount or seat/ride change).
//
// ScoringForm is the ONLY screen where every one of ring/classId/rideId/seat
// is simultaneously known and valid: a seat only resolves once a ride's class
// assignment (useAssignedPosition) has settled on one. Browsing ClassList/
// RideList/ClassGrid has no seat to report, so this store simply stays null
// there, and the heartbeat goes out with ring/seat null (#3549).
//
// usePresenceHeartbeat's interval reads this synchronously at send time; it
// never blocks on it and never renders off it (no consumer subscribes to
// changes), so a plain module-level variable — no React state, no listeners
// — is the whole store. Deliberately the SAME field set GET /presence
// returns as client claims (lib/presence.js file header), minus scribeSub/
// heartbeatAt, which score-api itself stamps server-side.
let current = null;

export function setPresenceLocation(location) {
  current = location;
}

export function clearPresenceLocation() {
  current = null;
}

export function getPresenceLocation() {
  return current;
}
